import amplifyOutputsJson from "amplify_outputs.json" with { type: "json" }
import { createContext } from "react"
import {
	EnvironmentConfigurationSchema,
	type EnvironmentConfiguration
} from "../schemata/configuration/EnvironmentConfiguration.js"
import ValidateOrFail from "../support/language/ValidateOrFail.js"

const amplifyOutputs = amplifyOutputsJson as { auth?: { aws_region: string } }

/**
 * @description
 *	A context that provides the whole configuration for this application. This
 *	context will take the values from the Amplify outputs JSON file, then from
 *	the available environment variables, and finally from a set of default
 *	values.
 */
const ConfigurationContext = createContext<EnvironmentConfiguration>(
	ValidateOrFail(EnvironmentConfigurationSchema, {
		AWS_REGION: amplifyOutputs.auth ? amplifyOutputs.auth.aws_region : process.env.NEXT_PUBLIC_AWS_DEFAULT_REGION,
		BIOMETRY_ORIGIN: process.env.NEXT_PUBLIC_BIOMETRY_ORIGIN,
		DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE,
		ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
		HTTP_CLIENT_TIMEOUT_IN_MILLISECONDS: process.env.NEXT_PUBLIC_HTTP_CLIENT_TIMEOUT_IN_MILLISECONDS
	})
)

export default ConfigurationContext
